<template>
  <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative transform overflow-hidden rounded-lg bg-gray-800 text-white shadow-xl transition-all sm:max-w-3xl w-full">
          <div class="p-6">
            <!-- หัวข้อและปุ่มปิด -->
            <div class="flex justify-between items-center mb-6">
              <h3 class="text-xl font-semibold text-indigo-300">แก้ไขแก๊งค์</h3>
              <button @click="$emit('cancelModal')" class="text-gray-400 hover:text-white">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <!-- Loading State -->
            <div v-if="isLoading" class="text-center py-4">
              <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-indigo-600 mx-auto"></div>
              <p class="mt-2 text-indigo-200">กำลังโหลดข้อมูล...</p>
            </div>
            <!-- Tab Navigation -->
            <div v-else class="flex border-b border-gray-700 mb-6">
              <button
                v-for="tab in tabs"
                :key="tab.id"
                @click="activeTab = tab.id"
                class="px-4 py-2 text-sm font-medium transition-colors duration-200"
                :class="activeTab === tab.id ? 'text-indigo-200 border-b-2 border-indigo-700' : 'text-gray-400 hover:text-indigo-300'"
              >
                {{ tab.name }}
              </button>
            </div>
            <!-- ฟอร์ม -->
            <form @submit.prevent="handleUpdateGang">
              <div class="space-y-4 h-96 overflow-auto mb-6">
                <!-- General Tab -->
                <div v-if="activeTab === 'general'" class="space-y-4">
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">ชื่อแก๊งค์</label>
                      <input
                        v-model="gangData.name"
                        type="text"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระดับแก๊งค์</label>
                      <select
                        v-model.number="gangData.level"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </select>
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">ลิงค์รูปภาพแก๊งค์</label>
                      <input
                        v-model="gangData.img"
                        type="url"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="https://example.com/image.jpg"
                        required
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">สถานที่แก๊งค์อาศัย</label>
                      <input
                        v-model="gangData.location"
                        type="text"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="เช่น ป่าช้า"
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนชาวบ้านขั้นต่ำเพื่อบุก</label>
                      <input
                        v-model.number="gangData.minVillagersToAttack"
                        type="number"
                        min="1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                  </div>
                </div>
                <!-- Members & Prerequisites Tab -->
                <div v-if="activeTab === 'members'" class="space-y-4">
                  <!-- รายชื่อชาวบ้านในแก๊งค์ -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">รายชื่อชาวบ้านในแก๊งค์</h4>
                    <div v-for="(member, index) in gangData.members" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                      <div class="col-span-10">
                        <input
                          v-model="gangData.members[index]"
                          type="text"
                          placeholder="ชื่อชาวบ้าน"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div class="col-span-2">
                        <button
                          v-if="index > 0"
                          @click="removeMember(index)"
                          type="button"
                          class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                          aria-label="ลบชาวบ้าน"
                        >
                          ลบ
                        </button>
                      </div>
                    </div>
                    <div class="flex gap-3 mt-3">
                      <button
                        @click="addMember"
                        type="button"
                        class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                      >
                        + เพิ่มชาวบ้าน
                      </button>
                    </div>
                  </div>
                  <!-- แก๊งค์ที่ต้องชนะก่อน -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">แก๊งค์ที่ต้องชนะก่อน</h4>
                    <div v-for="(prereq, index) in gangData.prerequisites" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                      <div class="col-span-10">
                        <input
                          v-model="gangData.prerequisites[index]"
                          type="text"
                          placeholder="ชื่อแก๊งค์"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div class="col-span-2">
                        <button
                          v-if="index > 0"
                          @click="removePrerequisite(index)"
                          type="button"
                          class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                          aria-label="ลบแก๊งค์"
                        >
                          ลบ
                        </button>
                      </div>
                    </div>
                    <div class="flex gap-3 mt-3">
                      <button
                        @click="addPrerequisite"
                        type="button"
                        class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                      >
                        + เพิ่มแก๊งค์
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Drops Tab -->
                <div v-if="activeTab === 'drops'" class="space-y-4">
                  <!-- ไอเทมที่ดรอปเมื่อชนะ -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">ไอเทมที่ดรอปเมื่อชนะ (พร้อมโอกาส 0-10000, 1000=10%)</h4>
                    <div v-for="(drop, index) in gangData.dropItems" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                      <div class="col-span-5">
                        <input
                          v-model="gangData.dropItems[index].itemName"
                          type="text"
                          placeholder="ชื่อไอเทม"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div class="col-span-5">
                        <input
                          v-model.number="gangData.dropItems[index].chance"
                          type="number"
                          min="0"
                          max="10000"
                          placeholder="โอกาส (0-10000)"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div class="col-span-2">
                        <button
                          v-if="index > 0"
                          @click="removeDropItem(index)"
                          type="button"
                          class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                          aria-label="ลบไอเทม"
                        >
                          ลบ
                        </button>
                      </div>
                    </div>
                    <div class="flex gap-3 mt-3">
                      <button
                        @click="addDropItem"
                        type="button"
                        class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                      >
                        + เพิ่มไอเทม
                      </button>
                    </div>
                  </div>
                  <!-- ไอเทมดรอปครั้งแรก -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">ไอเทมที่จะดรอปเมื่อชนะครั้งแรก</h4>
                    <div v-for="(firstDrop, index) in gangData.firstWinItems" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                      <div class="col-span-5">
                        <input
                          v-model="gangData.firstWinItems[index].itemName"
                          type="text"
                          placeholder="ชื่อไอเทม"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div class="col-span-5">
                        <input
                          v-model.number="gangData.firstWinItems[index].quantity"
                          type="number"
                          min="0"
                          placeholder="จำนวน (optional)"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div class="col-span-2">
                        <button
                          v-if="index > 0"
                          @click="removeFirstWinItem(index)"
                          type="button"
                          class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                          aria-label="ลบไอเทม"
                        >
                          ลบ
                        </button>
                      </div>
                    </div>
                    <div class="flex gap-3 mt-3">
                      <button
                        @click="addFirstWinItem"
                        type="button"
                        class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                      >
                        + เพิ่มไอเทม
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ปุ่มควบคุม -->
              <div class="flex justify-end gap-3">
                <button
                  type="button"
                  @click="handleDeleteGang"
                  class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition duration-200"
                >
                  ลบแก๊งค์
                </button>
                <button
                  type="submit"
                  class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                >
                  อัปเดตแก๊งค์
                </button>
                <button
                  @click="$emit('cancelModal')"
                  type="button"
                  class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition duration-200"
                >
                  ยกเลิก
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue';
import { projectFirestore } from '@/firebase/config';
export default {
  props: ['gangId'],
  emits: ['cancelModal', 'gangUpdated', 'gangDeleted'],
  setup(props, { emit }) {
    const gangData = ref({
      name: '',
      img: '',
      members: [''],
      dropItems: [{ itemName: '', chance: 0 }],
      firstWinItems: [{ itemName: '', quantity: 0 }],
      minVillagersToAttack: 1,
      level: 1,
      prerequisites: [''],
      location: ''
    });
    const isLoading = ref(true);
    const activeTab = ref('general');
    const tabs = ref([
      { id: 'general', name: 'ข้อมูลทั่วไป' },
      { id: 'members', name: 'สมาชิก & เงื่อนไขก่อนหน้า' },
      { id: 'drops', name: 'ไอเทมดรอป' },
    ]);
    // Members
    const addMember = () => {
      gangData.value.members.push('');
    };
    const removeMember = (index) => {
      if (gangData.value.members.length > 1) {
        gangData.value.members.splice(index, 1);
      }
    };
    // Drop Items
    const addDropItem = () => {
      gangData.value.dropItems.push({ itemName: '', chance: 0 });
    };
    const removeDropItem = (index) => {
      if (gangData.value.dropItems.length > 1) {
        gangData.value.dropItems.splice(index, 1);
      }
    };
    // First Win Items
    const addFirstWinItem = () => {
      gangData.value.firstWinItems.push({ itemName: '', quantity: 0 });
    };
    const removeFirstWinItem = (index) => {
      if (gangData.value.firstWinItems.length > 1) {
        gangData.value.firstWinItems.splice(index, 1);
      }
    };
    // Prerequisites
    const addPrerequisite = () => {
      gangData.value.prerequisites.push('');
    };
    const removePrerequisite = (index) => {
      if (gangData.value.prerequisites.length > 1) {
        gangData.value.prerequisites.splice(index, 1);
      }
    };
    const fetchGang = async () => {
      try {
        const doc = await projectFirestore.collection('gameGanks').doc(props.gangId).get();
        if (doc.exists) {
          gangData.value = { ...doc.data() };
          // Ensure arrays are initialized
          if (!gangData.value.members || gangData.value.members.length === 0) {
            gangData.value.members = [''];
          }
          if (!gangData.value.dropItems || gangData.value.dropItems.length === 0) {
            gangData.value.dropItems = [{ itemName: '', chance: 0 }];
          }
          if (!gangData.value.firstWinItems || gangData.value.firstWinItems.length === 0) {
            gangData.value.firstWinItems = [{ itemName: '', quantity: 0 }];
          }
          if (!gangData.value.prerequisites || gangData.value.prerequisites.length === 0) {
            gangData.value.prerequisites = [''];
          }
        } else {
          alert('ไม่พบข้อมูลแก๊งค์');
          emit('cancelModal');
        }
      } catch (error) {
        console.error('Error fetching gang:', error);
        alert(`เกิดข้อผิดพลาด: ${error.message}`);
      } finally {
        isLoading.value = false;
      }
    };
    onMounted(fetchGang);
    // Handle updating gang
    const handleUpdateGang = async () => {
      try {
        const gangName = gangData.value.name.trim();
        if (!gangName || /[/\.#$$$ $$]/.test(gangName)) {
          alert('ชื่อแก๊งค์ไม่ถูกต้อง ห้ามใช้ / . # $ [ ] หรือปล่อยว่าง');
          return;
        }
        // Filter valid arrays
        const filteredMembers = gangData.value.members.filter(member => member.trim());
        const filteredDropItems = gangData.value.dropItems.filter(drop => drop.itemName.trim() && drop.chance >= 0);
        const filteredFirstWinItems = gangData.value.firstWinItems.filter(firstDrop => firstDrop.itemName.trim());
        const filteredPrerequisites = gangData.value.prerequisites.filter(prereq => prereq.trim());
        const updateData = {
          name: gangName,
          img: gangData.value.img,
          members: filteredMembers,
          dropItems: filteredDropItems,
          firstWinItems: filteredFirstWinItems.map(item => ({ ...item, quantity: item.quantity || 1 })),
          minVillagersToAttack: gangData.value.minVillagersToAttack,
          level: Number(gangData.value.level),
          prerequisites: filteredPrerequisites,
          location: gangData.value.location
        };
        // Update gang in gameGanks collection
        await projectFirestore.collection('gameGanks').doc(props.gangId).update(updateData);
        emit('cancelModal');
      } catch (error) {
        console.error('Error updating gang:', error);
        alert(`เกิดข้อผิดพลาด: ${error.message}`);
      }
    };
    // Handle deleting gang
    const handleDeleteGang = async () => {
      if (window.confirm('แน่ใจว่าต้องการลบแก๊งค์นี้ใช่ไหม? การลบนี้ไม่สามารถย้อนกลับได้')) {
        try {
          await projectFirestore.collection('gameGanks').doc(props.gangId).delete();
          console.log('Gang deleted successfully:', props.gangId);
          emit('gangDeleted');
          emit('cancelModal');
        } catch (error) {
          console.error('Error deleting gang:', error);
          alert(`เกิดข้อผิดพลาดในการลบ: ${error.message}`);
        }
      }
    };
    return {
      gangData,
      isLoading,
      activeTab,
      tabs,
      handleUpdateGang,
      handleDeleteGang,
      addMember,
      removeMember,
      addDropItem,
      removeDropItem,
      addFirstWinItem,
      removeFirstWinItem,
      addPrerequisite,
      removePrerequisite
    };
  }
};
</script>
<style scoped>
.animate-fade-in {
  animation: fadeIn 0.3s ease-in;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>